/**
 * @ngdoc Controller
 * @name InstallationFileDownloadController
 */
import { handleFileDownload } from "@/utils/download";

(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('InstallationFileDownloadController', InstallationFileDownloadController);

    /**
     * @constructor
     * @ngInject
     */
    function InstallationFileDownloadController(locale, $state, $log, ApiService, $stateParams, vrmNotificationsService, vrmNotificationType) {
        $log.info('InstallationFileDownloadController');
        ApiService.installationDownload($stateParams.id, 'file-download', { filename: $stateParams.filename }, true).then(function (response) {
            handleFileDownload(response.data, $stateParams.filename.slice(2));
            $state.go('base.installation.dashboard');
        }, function () {
            locale.ready('errors').then(function () {
                vrmNotificationsService.add({ type: vrmNotificationType.ERROR, message: locale.getString('errors.file_no_longer_exists'), timeout: 30000 });
            });
            $state.go('base.installation.dashboard');
        })

    }
})();
